<template>
  <body class="fixed-header horizontal-menu horizontal-app-menu">
    <div class="header p-r-0 bg-primary m-b-10">
      <div class="header-inner header-md-height">
        <a
          href="#"
          class="btn-link toggle-sidebar d-lg-none text-white sm-p-l-0 btn-icon-link"
          data-toggle="horizontal-menu"
        >
          <i class="bi bi-list"></i>
        </a>
        <div class="">
          <div class="brand inline no-border d-sm-inline-block">
            <h4 class="text-white">ARCHIVE ONLINE MEDIA MONITORING</h4>
          </div>
        </div>
      </div>
    </div>
    <div class="page-container">
      <div class="page-content-wrapper">
        <div class="content">
          <div class="container-fluid container-fixed-lg">
            <router-view />
          </div>
        </div>
        <div class="container-fluid container-fixed-lg footer">
          <div class="copyright sm-text-center">
            <p class="small-text no-margin pull-left sm-pull-reset">
              Online Media Monitoring © 2020 All Rights Reserved.
            </p>
            <p class="small no-margin pull-right sm-pull-reset">
              Online Media Monitoring
              <span class="hint-text"> v{{ version }}</span>
            </p>
            <div class="clearfix" />
          </div>
        </div>
      </div>
    </div>
  </body>
</template>

<script>
import $ from "jquery";
import Cookie from "js-cookie";
import VueJwtDecode from "vue-jwt-decode";
export default {
  name: "MainLayout",
  data() {
    return {
      fullname: this.$store.getters.user.fullname,
      renew_call: false,
      version: process.env.VUE_APP_PACKAGE_VERSION,
    };
  },
  methods: {
    activeLink: function () {
      if (event.target.nodeName == "A") {
        var el = $(event.target).closest(".admin-menu");
        el.parent().children().removeClass("active");
        el.addClass("active");
      }
    },
    logout: function () {
      event.preventDefault();
      this.$store.dispatch("logout").then(() => {
        let ref = encodeURI(btoa("logout"));
        let teks = encodeURI(btoa("Anda berhasil keluar dari sistem."));
        let title = encodeURI(btoa("Berhasil!"));
        this.$router.push({
          path: "/login",
          query: { log: teks, ref: ref, log_t: title },
        });
      });
    },
  },
  created: function () {
    this.$http.interceptors.response.use(undefined, (error) => {
      let api = process.env.VUE_APP_API_URL + "renew-access";

      let refresh_token = Cookie.get("medmon_refresh");
      const originalRequest = error.config;

      if (error.response.status === 401 && originalRequest.url === api) {
        return Promise.reject(error);
      }

      if (error.response.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;

        if (typeof refresh_token !== "undefined") {
          let userID = this.$store.getters.user.user_id.$oid;
          let data = {
            "refresh-token": refresh_token,
            uid: userID,
          };

          return this.$http.post(api, data).then((res) => {
            if (res.status === 200) {
              let token = res.data["access-token"];
              this.$http.defaults.headers.common["token"] = token;

              let token_decode = VueJwtDecode.decode(token);
              let token_exp = token_decode.exp * 1000;
              let token_expire = new Date(token_exp);
              Cookie.set("medmon_ref", token, { expires: token_expire });

              return this.$http(originalRequest);
            }
          });
        }
      }

      return Promise.reject(error);
    });
  },
  mounted: function () {
    var path = this.$route.path;
    if (path == "/admin/visitor") {
      $("#visitor-link").addClass("active");
    } else {
      $("#dashboard-link").addClass("active");
    }
  },
};
</script>

<style scoped>
@import "../../../../public/pages/css/themes/modern.css";
.horizontal-app-menu .menu-bar > ul > li > a {
  padding: 0px 5px !important;
  color: #3f3f3f !important;
}
</style>